import { Component, OnInit } from "@angular/core";
import { PostOfficeProvider } from "src/app/services/post-office";
import { Client } from "src/app/services/API/client";
import { AgmCoreModule, AgmMap } from "@agm/core";
import { last } from "@angular/router/src/utils/collection";

@Component({
  selector: "app-branches-component",
  templateUrl: "./branches-component.component.html"
})
export class BranchesComponent implements OnInit {
  //inicializim te variablave te hartes
  markers;
  infos;
  loading = false;
  hasLocation = false;

  userLocation: any = { lat: null, lng: null };

  constructor(private client: Client) {}

  ngOnInit() {
    this.getBranches();

    this.getUserLocation();
  }

  // guida e marre nga https://angular-maps.com/guides/getting-started/
  //koordinatat e hartes
  lat: number = 41.328237;
  lng: number = 19.818387;
  isMapReady = false;

  //remove points of interest
  myStyles = [
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [{ visibility: "off" }]
    }
  ];

  // Therret Api dhe merr koordinatat e zyrave
  getBranches() {
    this.loading = true;
    //koordinatat
    return this.client
      .get("api/offices")
      .then((res: any) => {
        //get markers
        this.markers = res;
        this.loading = false;
        return res;
      })
      .catch((err: any) => {
        this.loading = false;
        return err;
      });
  }

  getUserLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.hasLocation = true;
        this.userLocation.lat = position.coords.latitude;
        this.userLocation.lng = position.coords.longitude;
      });
    } else {
      /* geolocation IS NOT available */
    }
  }

  zoomChange(event) {}
}
